import React from 'react';
import Sketch from 'react-p5';
import {bfs,dfs,astar,dijkstra} from './algorithms';
import "./pathfinder.css";
let visitors=[];
let path=[];
let rows,cols;
let nodes=[];
let algorithm="bfs";
let increment=0.006;
let randommaze=false;

let res=30;
let setstart=false;
let setend=false;
let start,end;
let cst=0,visualise=false;


function node(x,y){

	this.x=x;
	this.y=y;
	this.f=0;
	this.g=0;
	this.h=0;
	this.d=0;
	this.iswall=false;
	this.visited=false;
	this.parentset=false;
	this.parent=null;
	this.isbetween=false;
	this.ispath=false;
	this.isstart=false;
	this.isend=false;
	this.display=(p5)=>{
		if(this.isstart){
			p5.fill(225,0,0);
		}
		else if(this.isend){
			p5.fill(0,255,0);
		}
		else if(this.isbetween){
			if(this.ispath){
				p5.fill('rgb(139,0,139)');
			}
			else{
                p5.fill('rgba(105,105,255,0.8)');	
                // p5.fill('rgb(204,204,0)')
			}
			
		}
		else if(this.iswall){
			p5.fill('grey');
		}
		
		else{
			p5.noFill();
		}
		
        p5.strokeWeight(0.4);
		p5.stroke(255);
		p5.rect(this.x,this.y,res,res)
		
		if(visualise && cst<=visitors.length){
			changeit();
		}
			if(p5.floor(cst)>=visitors.length){
				for(let p=0;p<path.length;p++){
					let x=path[p][0],y=path[p][1];
					
					nodes[x][y].ispath=true;
				}
			}
	
	}


}



function changeit(){
	

		for(let k=0;k<cst;k++){

			let x=visitors[k][0];
			let y=visitors[k][1];
			nodes[x][y].isbetween=true
			
			
		}
		
		cst+=increment;
	
}








const setup=(p5,parent)=>{
	let dimx=p5.floor((2*p5.displayWidth/3)/res),dimy=p5.floor((2*p5.displayWidth/3)/res);
    p5.createCanvas(res*dimx,res*dimy).parent(parent);
    cols=p5.width/res;
	rows=p5.height/res;
	for(let i=0;i<rows;i++){
		let temp=[]
		for(let j=0;j<cols;j++){
			temp.push(new node(i*res,j*res))

		}
        nodes.push(temp);
        


	}
    

}

const draw=(p5)=>{

    p5.background(0);
    for(let i=0;i<nodes.length;i++){
		for(let j=0;j<nodes[i].length;j++){
			nodes[i][j].display(p5)
		
		
		}
	}


}

function mousePressed(p5){
	if(p5.mouseX>=0 && p5.mouseX<=p5.width && p5.mouseY>=0 && p5.mouseY<=p5.height){
	if(setstart===false){

        let x=p5.floor(p5.mouseX/res),y=p5.floor(p5.mouseY/res);
        start=[x,y];
        setstart=true;
        nodes[x][y].isstart=true;
	
	}
		else if(setend===false){
			
			let x=p5.floor(p5.mouseX/res),y=p5.floor(p5.mouseY/res);
			if(!nodes[x][y].isstart){
				end=[x,y];
        setend=true;
        nodes[x][y].isend=true;


			}
			
           
            
            
            
        }
    }




}
function keyPressed(p5){
	console.log(p5.keyCode);
	if(p5.keyCode===86){
		visual()
	}
	if(p5.keyCode===82){
		resetit()
	}
	if(p5.keyCode===83){
		resetwalls()
	}
}

function mouseDragged(p5){
    if(p5.mouseX>=0 && p5.mouseX<=p5.width && p5.mouseY>=0 && p5.mouseY<=p5.height){
	let x=p5.floor(p5.mouseX/res)
	let y=p5.floor(p5.mouseY/res)
	if(nodes[x][y].isstart===false && nodes[x][y].isend===false)
	nodes[x][y].iswall=true;
}
}

const changealgo=(e)=>{
    
    algorithm=e.target.value;
}
const visual=()=>{
    
    if(setstart && setend ){
        if(algorithm==="bfs"){
            
        let q=bfs(start,end,nodes,visitors,path,rows,cols,res);
      nodes=q[0];
      visitors=q[1];
      path=q[2];
      visualise=true;

        }
    else if(algorithm==="dfs"){
        let q=dfs(start,end,nodes,visitors,path,rows,cols,res);
      nodes=q[0];
      visitors=q[1];
      path=q[2];
      visualise=true;
	}
	else if(algorithm==="astar"){
		let q=astar(start,end,nodes,visitors,path,rows,cols,res);
      nodes=q[0];
      visitors=q[1];
      path=q[2];
      visualise=true;

	}
	else if (algorithm==="dijkstra"){
		let q=dijkstra(start,end,nodes,visitors,path,rows,cols,res);
		nodes=q[0];
		visitors=q[1];
		path=q[2];
		visualise=true;

	}
    }


}

const resetit=()=>{
    
    for(let i=0;i<nodes.length;i++){
        for(let j=0;j<nodes[i].length;j++){
            nodes[i][j].iswall=false;
	nodes[i][j].visited=false;
	nodes[i][j].parentset=false;
	nodes[i][j].parent=null;
	nodes[i][j].isbetween=false;
	nodes[i][j].ispath=false;
	nodes[i][j].isstart=false;
	nodes[i][j].isend=false;
	nodes[i][j].f=0;
	nodes[i][j].g=0;
	nodes[i][j].h=0;
	nodes[i][j].d=0;
        }
    }
    visitors=[];
    path=[];
    setstart=false;
    setend=false;
    visualise=false;
    cst=0;
    randommaze=false;


}
const resetwalls=()=>{
	for(let i=0;i<nodes.length;i++){
        for(let j=0;j<nodes[i].length;j++){
			
            nodes[i][j].iswall=false;
	nodes[i][j].visited=false;
	nodes[i][j].parentset=false;
	nodes[i][j].parent=null;
	nodes[i][j].isbetween=false;
	nodes[i][j].ispath=false;
	nodes[i][j].f=0;
	nodes[i][j].g=0;
	nodes[i][j].h=0;
	nodes[i][j].d=0;
	if(nodes[i][j].isstart===false){
		nodes[i][j].isstart=false;
	}
	if(nodes[i][j].isend===false){
		nodes[i][j].isend=false;
	}
	
	
        }
    }
    visitors=[];
    path=[];
    
    visualise=false;
    cst=0;
    randommaze=false;





} 


// const randmaze=()=>{
	
// 	if(randommaze===false){
// 	randommaze=true;
// 	for(let i=0;i<nodes.length;i++){
// 		for(let j=0;j<nodes[i].length;j++){
// 			if(!nodes[i][j].isstart && !nodes[i][j].isend){
				
// 					nodes[i][j].iswall=false;
// 					nodes[i][j].f=0;
// 					nodes[i][j].g=0;
// 					nodes[i][j].h=0;
// 					nodes[i][j].iswall=false;
// 					nodes[i][j].visited=false;
// 					nodes[i][j].parentset=false;
// 					nodes[i][j].parent=null;
// 					nodes[i][j].isbetween=false;
// 					nodes[i][j].ispath=false;
// 					visualise=false;
// 					visitors=[];
//     				path=[];
//     				cst=0;
// 				if(Math.random()<0.25){
// 					nodes[i][j].iswall=true;
// 				}
// 			}

// 		}


// 	}

// 	}

// }










export default function Pathfinder() {
    return (
        <div className="container">
            <center><h2>Path Finder</h2></center>
            <center><h3>How to use:first click sets start,second click sets finish point,drag the mouse to create obstacles</h3></center><br/>
            <label><h3>Shortcuts:V-visualize,R-reset,S-resetwalls</h3></label><br/>
			<center><label><strong>SELECT ALGORITHM: </strong></label>
                <select onChange={changealgo} >
                    <option value="bfs">Breadth First Search</option>
                    <option value="dfs">depth First Search</option>
					<option value="astar">A STAR</option>
					<option value="dijkstra">DIJKSTRA</option>


                </select>
				


            </center>
			
			<button  className="visualbtn" onClick={visual} >VISUALISE</button>
            <button className="resetbtn" onClick={resetit}>RESET</button>
			{/* <button onClick={randmaze}>Random Maze</button> */}
			<br />
            <div className="maze"><Sketch setup={setup} draw={draw} mousePressed={mousePressed} mouseDragged={mouseDragged} keyPressed={keyPressed} /></div>
        </div>
    )
}
